import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { reduxForm, Field } from 'redux-form';
import translate from '../TranslateHOC';
import { renderCheckBoxTermsField } from '../../form_helpers';
import Isvg from 'react-inlinesvg';
import error from '../../img/icons/error.svg';
import { Button as ButtonV2 } from '../../v2/components/button/Button';

const submit = (values, dispatch, props) => {
  if (values.age) {
    props.handleConfirm();
  } else {
    props.handleCancel();
  }
};

class VerifyAgeForm extends Component {
  render() {
    const {
      handleSubmit,
      submitting,
      pristine,
      strings,
      handleCancel,
      contentWarnings,
    } = this.props;

    return (
      <div className="dialog--verify-age">
        <div className="dialog__title">{strings.contentWarningTitle}</div>
        <ul className="dialog__list">
          {contentWarnings &&
            contentWarnings.length > 0 &&
            Object.keys(contentWarnings).map((key) => {
              return (
                <li key={key} className="dialog__item">
                  <Isvg className="icon" src={error} />
                  <span
                    dangerouslySetInnerHTML={{
                      __html: contentWarnings[key].warning_text,
                    }}
                  />
                </li>
              );
            })}
        </ul>

        <div className="dialog__instruction">
          {strings.contentWarningChallenge}
        </div>
        <form className="dialog__form" onSubmit={handleSubmit(submit)}>
          <div className="form__checkbox-holder">
            <Field
              name="age"
              type="checkbox"
              component={renderCheckBoxTermsField}
              label={strings.contentWarningConfirm}
              on={strings.yes}
              off={strings.no}
            />
          </div>
          <ButtonContainer>
            {
              <button
                className="dialog__btn dialog__btn--cancel"
                type="button"
                onClick={handleCancel}
              >
                {strings.cancel}
              </button>
            }
						<ButtonV2
              onClick={handleSubmit(submit)}
              label={strings.ok}
              size="small"
							disabled={pristine || submitting}
            />
          </ButtonContainer>
        </form>
      </div>
    );
  }
}

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 2em;
  align-items: center;
  justify-content: right;
  button {
    margin-right: 20px;
  }
`;

VerifyAgeForm = reduxForm({
  form: 'verifyAge',
})(VerifyAgeForm);

export default translate(VerifyAgeForm);
